import React, { useState, useRef, useEffect } from 'react';
import {
    FormControl, FormControlLabel, Typography, TextField, RadioGroup, Radio, Checkbox,
    Button, Box, FormHelperText, Autocomplete, Select, InputLabel, MenuItem, InputAdornment,
    IconButton
} from '@mui/material';
// import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import dayjs from 'dayjs';
// import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { Formik, useFormik } from 'formik';
import * as yup from 'yup';
import { useSelector, useDispatch } from 'react-redux';
import { fetchBuyersByCompanyId } from '../../../redux/shipmentSlice';
import linkIcon from '../../../assets/images/link.svg'
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { useNavigate } from 'react-router-dom';
import { ProductColumnDefFn } from '../columns/ColumnDefShipment.js';
import MainTable from '../../../components/Table/PaginationTable';
import LinkedOrdersModalShipment from './LinkedShipmentModal'
import { fetchOrdersToLink } from '../../../redux/shipmentSlice';

dayjs.extend(localizedFormat);
const formattedDate = dayjs().format('LL');


// Create a new object with the shape of our input initial state variable.const 
const nonEngChar = /[^-A-Za-z0-9_@,.:;{}/&%()'"#*<>!$?+\n ]/;
export const CONFIRM_SHIPMENT_VALIDATION = yup.object().shape({
    invoiceNumber: yup.string().required('Seller Invoice Number cannot be empty.')
    .max(100, 'Seller Invoice Number cannot exceed 100 characters')
    .test('non-eng-char', 'Please enter English characters only.', (value) => !nonEngChar.test(value)),
    buyerCompanyKeyId: yup.string().required('Buyer is required.'),
    invoiceDate: yup.date().required('Invoice date is required.'),
    // sellerUnit: yup.string().required('Seller Unit is required.'),
    // buyerUnit: yup.string().required('Buyer Unit is required.'),
    // shipmentTransportMode: yup.string().required('Transport Mode is required.'),
    // shipmetDescription: yup.string().required('Order description is required.'),

})
const ConfirmShipment = ({ onSubmit, handleStepChange, handleBack, productColumn }) => {

    const navigate = useNavigate();
    const navigateToOutboxLandingPage = () => {
        navigate("/outbox-shipment")
    }
    const handleLinkIcon = () => {
        // console.log("insideeeeee")
    }
    const dispatch = useDispatch()
    const shipmentInfo = useSelector(state =>
        state.shipment.shipmentDetails
            ? state.shipment.shipmentDetails.data
            : []);
    const shipmentProducts = useSelector(state =>
        state.shipment.shipmentDetails && state.shipment.shipmentDetails.data
            ? state.shipment.shipmentDetails.data.shipmentProducts
            : []);
    const buyerList = useSelector(state => state.shipment?.buyers?.data || []);
    const buyerBusinessUnit = useSelector(state => state.shipment?.buyerBusinessUnit || []);
    const sellerBusinessUnit = useSelector(state => state.shipment?.sellerBusinessUnit || []);
    const linkedOrders = useSelector(state => state.shipment?.linkingOrders?.data || []) 

    const [initialState, setInitialState] = useState({
        invoiceNumber: shipmentInfo?.invoiceNumber || '',
        invoiceDate: dayjs(shipmentInfo?.invoiceDate) || dayjs(),
        shipmentTransportMode: shipmentInfo?.shipmentTransportMode || '',
        shipmentDescription: shipmentInfo?.shipmentDescription || '',
        buyerCompanyBuId: shipmentInfo?.buyerCompany?.companyBuId || '',
        sellerCompanyBuId: shipmentInfo?.sellerCompany?.companyBuId || '',
        forestCompanyKeyId: shipmentInfo?.forestCompanyKeyId || '',
        buyerCompanyKeyId: shipmentInfo?.buyerCompany?.companyId || '',
        isLinked: shipmentInfo?.isLinked || 0,
        orderNumber: shipmentInfo?.orderNumber || ''
    })
    const supplierList = useSelector(state => state.shipment?.buyers?.data || []);

    const [modalOpen, setModalOpen] = useState(false);
    const handleOpenModal = () => {
        if(initialState.buyerCompanyKeyId){
            setModalOpen(true);
            dispatch(fetchOrdersToLink({buyerCompanyKeyId: initialState.buyerCompanyKeyId, searchText:'', pageNumber:1, pageSize:10, toDate:'', fromDate:'' }))
        } else {
            toast.error('Please choose a buyer First')
        }
    }
    const handleCloseModal = () => setModalOpen(false);

    const buyerOptions = supplierList.map((supplier) => ({
        label: supplier.company_name, // Displayed in the dropdown
        value: supplier.company_key_id, // Actual value when an option is selected
    }));

    const { loading } = useSelector((state) => state.shipment);
    useEffect(() => {
        try{
        dispatch(fetchBuyersByCompanyId());
        }
        catch(err){
            console.log("Error occurred:",err);
          }
    }, [dispatch]);

    // const productColumn = ProductColumnDefFn(handleStepChange);

    return (
        <>

            {/* with Formik */}
            <Formik
                initialValues={initialState}
                // enableReinitialize={true}
                validationSchema={CONFIRM_SHIPMENT_VALIDATION}
                onSubmit={(values, { setSubmitting }) => {
                    const formattedValues = {
                        ...values,
                        invoiceDate: dayjs(values.invoiceDate).format('YYYY-MM-DD'),
                    };
                    // console.log('Formatted Submit:', formattedValues);
                    // console.log('Values Submit:', values);
                    onSubmit(formattedValues);
                    setSubmitting(false);
                }}

            >
                {({ values, errors, handleChange, handleBlur, handleSubmit, setFieldValue, touched }) => (
                    <form onSubmit={handleSubmit}>
                        <div className="row">
                            <div className="col-md-4 cs-form mb-3">
                                <TextField
                                    label='Seller Invoice Number'
                                    className='md-input'
                                    name='invoiceNumber'
                                    value={values.invoiceNumber}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={errors.invoiceNumber}
                                    helperText={errors.invoiceNumber}
                                />
                            </div>
                            <div className="col-md-4 cs-form mb-3">
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        label="Invoice Date"
                                        className='md-input'
                                        value={values.invoiceDate}
                                        onChange={(newValue) => {
                                            setFieldValue('invoiceDate', newValue);
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                className='md-input'
                                                error={errors.invoiceDate}
                                                helperText={errors.invoiceDate}
                                            />
                                        )}
                                    />
                                </LocalizationProvider>
                            </div>
                            <div className="col-md-4 cs-form mb-3">
                                {/* <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            className='md-input'
                            options={supplier}
                            value={values.buyerCompanyKeyId}
                            onChange={(event, newValue) => {
                                handleChange({ target: { name: 'buyerCompanyKeyId', value: newValue?.label || '' } });
                            }}
                            onBlur={handleBlur}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Supplier"
                                    error={errors.buyerCompanyKeyId}
                                    helperText={errors.buyerCompanyKeyId}
                                />
                            )}
                        /> */}
                                <Autocomplete
                                    disablePortal
                                    id="combo-box-demo"
                                    className='md-input'
                                    options={buyerOptions}
                                    getOptionLabel={(option) => option.label || ''}
                                    value={buyerOptions.find(option => option.value === values.buyerCompanyKeyId) || null}
                                    onChange={(event, newValue) => {
                                        handleChange({ target: { name: 'buyerCompanyKeyId', value: newValue?.value || '' } });
                                    }}
                                    onBlur={handleBlur}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Buyer"
                                            error={touched.buyerCompanyKeyId && Boolean(errors.buyerCompanyKeyId)}
                                            helperText={touched.buyerCompanyKeyId && errors.buyerCompanyKeyId}
                                        />
                                    )}
                                />
                            </div>
                            <div className="col-md-4 cs-form mb-3">
                                <FormControl className='md-input'
                                >
                                    <InputLabel id="seller-unit">Seller Unit</InputLabel>
                                    <Select
                                        labelId="seller-unit"
                                        name="sellerCompanyBuId"
                                        value={values.sellerCompanyBuId}
                                        label="Seller Unit"
                                        onChange={(event, newValue) => {
                                            // handleChange(event);
                                            handleChange({ target: { name: 'sellerCompanyBuId', value: event.target.value || '' } })
                                            // console.log("event.target.value",event.target.value,"newValue",newValue);
                                            // setInitialState({...initialState, sellerCompanyBuId: event.target.value});
                                        }}
                                        error={errors.sellerCompanyBuId}
                                        helperText={errors.sellerCompanyBuId}
                                    >
                                        {sellerBusinessUnit.map((option) => (
                                            <MenuItem key={option.companyBuId} value={option.companyBuId}>
                                                {option.companyBuName}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>
                            <div className="col-md-4 cs-form mb-3">
                                <FormControl className='md-input'
                                >
                                    <InputLabel id="buyer-unit">Buyer Unit </InputLabel>
                                    <Select
                                        labelId="buyer-unit"
                                        name="buyerCompanyBuId"
                                        value={values.buyerCompanyBuId}
                                        label="Buyer Unit"
                                        onChange={(event) => {
                                            handleChange(event);
                                            // console.log("event.target.value buyerCompanyBuId",event.target.value);
                                            // setInitialState({...initialState, buyerCompanyBuId: event.target.value});
                                        }}
                                        error={errors.buyerCompanyBuId}
                                        helperText={errors.buyerCompanyBuId}
                                    >
                                        {buyerBusinessUnit.map((option) => (
                                            <MenuItem key={option.companyBuId} value={option.companyBuId}>
                                                {option.companyBuName}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>
                            <div className="col-md-4 cs-form mb-3">
                                <FormControl className='md-input'
                                >
                                    <InputLabel id="transport-mode">Transport Mode</InputLabel>
                                    <Select
                                        labelId="transport-mode"
                                        name="shipmentTransportMode"
                                        value={values.shipmentTransportMode}
                                        label="Transport Mode"
                                        onChange={handleChange}
                                        error={errors.shipmentTransportMode}
                                        helperText={errors.shipmentTransportMode}
                                    >
                                        <MenuItem value="Rail Transport">Rail Transport</MenuItem>
                                        <MenuItem value="Road Transport">Road Transport</MenuItem>
                                        <MenuItem value="Air Transport">Air Transport</MenuItem>
                                        <MenuItem value="Ship Transport">Ship Transport</MenuItem>
                                        {/* ... other units */}
                                    </Select>
                                </FormControl>
                            </div>
                            <div className="col-md-12 cs-form mb-3">
                                <TextField
                                    label='Shipment Description'
                                    className='md-input'
                                    name='shipmentDescription'
                                    multiline
                                    rows={4}
                                    value={values.shipmentDescription}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={errors.shipmentDescription}
                                    // helperText={.errors.shipmetDescription}
                                    inputProps={{
                                        maxLength: 300,
                                    }}
                                    helperText={`${values.shipmentDescription?.length}/300`}
                                />
                            </div>
                            <div className="col-md-12 cs-form mb-3">
                            <TextField
                                fullWidth
                                variant="outlined"
                                className="md-input"
                                value={values.orderNumber}
                                disabled={true}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                                color="primary"
                                                onClick={handleOpenModal}
                                                component="span"
                                            >
                                                <span className="ms-2"><img src={linkIcon} alt="Link" /></span>
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                            />
                            <LinkedOrdersModalShipment
                                open={modalOpen}
                                onClose={handleCloseModal}
                                // buyerCompanyKeyId={values.buyerCompanyKeyId}
                                orders={linkedOrders}
                                // handleLink={(order) => handleLinkOrder(order, setValues)}
                                // handleUnlink={() => handleUnlinkOrder(setValues)}
                                // isLinked={isLinked}
                                // setIsLinked={setIsLinked}
                                // order={order}
                                // setOrder={setOrder}
                                // currentStep={currentStep}
                                // handleNextStep={handleNextStep}
                            />
                        </div>
                            <div className="d-flex justify-content-between mt-3">
                                <button type="button" className="btn btn-light grey-btn lg-btn" onClick={handleBack}>Back</button>
                                {/* <Button color="primary" variant="contained" type="submit" disabled={isSubmitting}>
                                    Create Order
                                </Button> */}
                                <div>
                                    <button
                                        className="btn btn-primary greeen-btn lg-btn me-3 "
                                        type='submit'
                                        variant="contained"
                                        onClick={handleBack} 
                                    // disabled={ isValid || isSubmitting }
                                    >
                                        {/* Create Order */}
                                        Add Product +
                                    </button>
                                    <button
                                        className="btn btn-primary greeen-btn lg-btn"
                                        type='submit'
                                        variant="contained"
                                        onClick={handleSubmit} // Use onClick to trigger form submission
                                    // disabled={ isValid || isSubmitting }
                                    >
                                        {/* Create Order */}
                                        Create
                                    </button>
                                </div>
                            </div>

                            {/* <button type="submit" className="btn btn-primary greeen-btn lg-btn" disabled={loading}>
                                    {loading ? 'Submitting...' : 'Create Order'}</button>
                            </div> */}
                            {/* ... other input fields */}
                        </div>
                    </form>
                )}
            </Formik >

            <div className='mt-5 ml-2'>
                <h1 className="fprimary">Product Details</h1>
            </div>
            <MainTable
                columns={productColumn}
                data={shipmentProducts}
                enablePagination={false}
                className='mt-5'
            // initialPageSize={pageSize}
            // pageNumber={pageNumber} // Use the correct prop name as expected by MainTable
            // onPageSizeChange={handlePageSizeChange}
            // onPageIndexChange={handlePageIndexChange}
            />
        </>
    )
}
export default ConfirmShipment